import React from 'react';
import { Text } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import * as Yup from "yup";
import InputField from "src/components/common/Inputs/InputField";
import { CustomButton } from "src/components/common/Buttons/CustomButton";

const schema = Yup.object().shape({
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

interface LearnerSignInFormProps {
  onSubmit: (values: any) => void;
  loading: boolean;
  error?: string;
  handleForgotPassword: () => void
}

export const LearnerSignInForm: React.FC<LearnerSignInFormProps> = ({ onSubmit, loading, error, handleForgotPassword }) => {
  const form = useForm({
    initialValues: {
      username: "",
      password: "",
    },
    validate: yupResolver(schema),
    validateInputOnBlur: true,
    validateInputOnChange: true,
  });

  const termsOfUse = () => {
    window.open('/Terms_of_Use_for_MYAi.pdf')
  }

  const privacyPolicy = () => {
    window.open('/Privacy_Policy_for_MYAi.pdf')
  }

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <InputField
        label="Username"
        name="username"
        inputContainerClassName='h-11 sm:h-16'
        placeholder="Enter your username"
        error={form.errors.username}
        {...form.getInputProps('username')}
      />
      <InputField
        label="Password"
        type="password"
        name="password"
        inputContainerClassName='h-11 sm:h-16'
        placeholder="Enter your password"
        showPasswordToggle
        error={form.errors.password}
        {...form.getInputProps('password')}
      />
      <div className="flex justify-between items-center my-5">
        <label className="flex items-center">
          <input type="checkbox" className="mr-2" />
          <span className="text-sm text-gray-600">Remember me</span>
        </label>
        <a onClick={handleForgotPassword} className="text-sm text-blue-600 cursor-pointer">Forgot Password?</a>
      </div>
      <Text className="text-sm text-gray-600 my-5">
      By signing in, you agree to our <a onClick={termsOfUse} className="text-blue-600 cursor-pointer">Terms of Use</a> and <a onClick={privacyPolicy} className="text-blue-600 cursor-pointer">Privacy Policy</a>.
      </Text>
      <CustomButton type="submit" loading={loading} disabled={!form.isValid()}>Sign In</CustomButton>
      {error && <Text color="red" className="mt-2">{error}</Text>}
    </form>
  );
};